{
  "title": "إيصال حوالة",
  "direction": "الاتجاه",
  "directions": {
    "BANK_TO_CASH": "من بنك إلى نقد",
    "CASH_TO_BANK": "من نقد إلى بنك"
  },
  "date": "التاريخ",
  "time": "الوقت",
  "transferNumber": "رقم الحوالة",
  "amount": "مبلغ الحوالة",
  "amountReceived": "المبلغ المستلم من العميل",
  "commission": "العمولة",
  "netCash": "صافي النقد المسلّم",
  "netTransferred": "المبلغ المحول",
  "sender": "المرسل",
  "receiver": "المستلم",
  "bankName": "اسم البنك",
  "employee": "الموظف",
  "commissionMode": "طريقة احتساب العمولة",
  "commissionModes": {
    "DEDUCTED": "تخصم من المبلغ",
    "ADDED": "تضاف على المبلغ"
  }
}
